import { render, staticRenderFns } from "./noLogin.vue?vue&type=template&id=2f0486be&"
import script from "./noLogin.vue?vue&type=script&lang=js&"
export * from "./noLogin.vue?vue&type=script&lang=js&"
import style0 from "./noLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports